import { render, staticRenderFns } from "./UpdateCompanyStructureModal.vue?vue&type=template&id=0f1b41de"
import script from "./UpdateCompanyStructureModal.vue?vue&type=script&lang=js"
export * from "./UpdateCompanyStructureModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateCompanyStructureModal.vue?vue&type=style&index=0&id=0f1b41de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports